
import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'
import RoomData from '@/types/RoomData'
import HelperTooltip from '@/components/HelperTooltip.vue'

export default Vue.extend({
  components: {
    HelperTooltip
  },

  props: {
    title: String,
    subtitle: String,
    propKey: String,
    topMargin: Number,
    boldTitle: { type: Boolean, default: true },
    help: { type: String, default: '' }
  },

  computed: {
    ...mapFields([
      'roomsData'
    ]),

    roomsWithoutCeilingHeatingSelected (): RoomData[] {
      const ceilingTypes = ['plaster', 'board', 'cdp400', 'slab16']
      const controlTypes = ['rpRtd', 'rpCtm']

      if (ceilingTypes.includes(this.propKey)) {
        return (this as any).roomsData.filter((room: RoomData) => // eslint-disable-line
          ceilingTypes.every((ceilingType: string) => !room[ceilingType as keyof RoomData] || this.propKey === ceilingType)
        )
      } else if (controlTypes.includes(this.propKey)) {
        return (this as any).roomsData.filter((room: RoomData) => // eslint-disable-line
          controlTypes.every((controlType: string) => !room[controlType as keyof RoomData] || this.propKey === controlType)
        )
      }

      return (this as any).roomsData // eslint-disable-line
    }
  },

  methods: {
    selectionChanged (selected: any, type: string) {//eslint-disable-line
      this.$store.commit('setRoomProperty', { selected, type })
    },

    getIndex (item: RoomData): number {
      return ((this as any).roomsData as RoomData[]).findIndex(room => room.name === item.name) //eslint-disable-line
    }
  }
})
